import { InjectionToken } from '@angular/core';
import { RemoveResult } from '@awesome-cordova-plugins/file/ngx';
import { Mutex } from 'async-mutex';
import { Observable } from 'rxjs';

export interface FileStorageServiceInterface {
    storeCompressedData<T>(mutex: Mutex, storageId: string, data: T, timestamp?: number): Observable<T>;
    loadCompressedData<T>(mutex: Mutex, storageId: string): Observable<T>;
    loadCompressedDataWithTimestamp<T>(mutex: Mutex, storageId: string): Observable<{ data: T; timestamp: number }>;
    checkCompressedData(mutex: Mutex, storageId: string): Observable<boolean>;
    removeCompressedData(mutex: Mutex, storageId: string): Observable<void | RemoveResult>;
}

export const FileStorageInjectionToken = new InjectionToken<FileStorageServiceInterface>('FileStorageServiceInterface');
